import { Injectable } from '@angular/core';
import { AppService } from '../shared/app.service';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { state2, IStateOptions, cacheTimeMax, IStateOptions2, ISearchResult } from '../shared/state';
import { map } from 'rxjs/operators';
import { ICommonSearchArgs } from 'src/app/shared/common-search-args';


// zoek argumenten zijn allemaal string omdat ze van queryparameters komen
export interface IDocumentZittingSearchArgs extends ICommonSearchArgs {
  // SearchFor: string;
  // CurrentPage: string;
  // SoortZittingId?: string;
  // PeriodeFilter?: string;
  // CombineWordsWith: ' or ' | ' and ';
  // VanJaar?: number;
  // TotJaar?: number;
}
export interface IDocumentZittingResultItem {
  Datum: Date | string;
  SoortZitting: string;
  ZittingId: number;
  SoortZittingId: number;
  DocumentZittingId: number;
  Titel: string;
  isZittingBreak?: boolean;
  Verwijzing: string;
}

export interface IPeriodeFilter {
  Title: string;
  arg: string | null;
  Tooltip?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ZoekDocumentZittingService {

  periodeFilters: IPeriodeFilter[];
  constructor(private appService: AppService, private http: HttpClient) {
    this.periodeFilters = [
      { Title: 'Huidig jaar', arg: 'y' },
      { Title: 'Afgelopen maand', arg: '-1m' },
      { Title: 'Afgelopen jaar', arg: '-1y' },
      { Title: 'Afgelopen 2 jaar', arg: '-2y' },
      { Title: 'Aangepaste periode', arg: 'C' }
    ];

  }


  getPeriodeFilters() { return this.periodeFilters; }

  private getDocumentZittingResultItemsWithExt(documentZittingResultItems: IDocumentZittingResultItem[]) {
    documentZittingResultItems.forEach(i => i.Titel = this.appService.getTitelWithExtension(i.Titel, i.Verwijzing));
    return documentZittingResultItems;
  }

  zoek(searchArgs: ICommonSearchArgs) {
    const url = this.appService.getUrl('api/ZoekDocumentZitting/search');
    if (!searchArgs.SearchFor) {
      const emptyResult: ISearchResult<IDocumentZittingResultItem> = {
        hasMoreResults: false,
        items: [],
        page: 0
      };
      return of(emptyResult);
    }
    const stateoptions = window.history.state as IStateOptions2;
    stateoptions.pageSize = 20;
    if (!stateoptions.concat) { searchArgs.CurrentPage = 0; }

    const getDocumentZittingWithExt$ = this.http.post<IDocumentZittingResultItem[]>(url, searchArgs).pipe(
      map(documentZittingResultItems => this.getDocumentZittingResultItemsWithExt(documentZittingResultItems))
    );
    return state2.getSearchResultOrDefault('documentzittingsearchdata',
      getDocumentZittingWithExt$,
      stateoptions);
  }
}
